import { render, staticRenderFns } from "./GeneralProfile.vue?vue&type=template&id=91a8d09a&scoped=true&"
import script from "./GeneralProfile.vue?vue&type=script&lang=js&"
export * from "./GeneralProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a8d09a",
  null
  
)

export default component.exports